import { graphql } from '@prophecy/graphql-types/graphql';
import { userGitCredsQuery } from '../git/GitIntegration/queries';
import { ProjectContentCountFields, ProjectSqlContentCountFields } from './ProjectContentFields';
export const projectDetailQuery = graphql(`
  query ProjectDetailQuery($projectId: String!) {
    Project(uid: $projectId) {
      _id
      name
      hasAnalysis
      isExampleProject
      team {
        _id
        name
      }
      pipelinesCount
      defaultTransformationEntity
      language
      providerType
      created
      createdBy
      mainBranch
      forkMode
      syncMode
      latestAttemptedReleaseVersion
      clonedReleaseVersion
      publishedToPackageHub
      versionControlMode
    }
  }
`);
export const projectReleasesQuery = graphql(`
  query ProjectReleaseList($projectId: String, $statuses: [ReleaseStatus!]!) {
    ProjectReleaseByProjectIdAndStatus(optionalProjectUID: $projectId, statuses: $statuses) {
      releaseTag
      createdAt
      createdByFullName
      tagMessage
      status
    }
  }
`);
export const SqlProjectAboutQuery = graphql(`
    query SqlProjectAboutQuery($projectId: String!) {
      Project(uid: $projectId) {
        _id
        description
        readme
        team {
          _id
          name
        }
        providerType
        created
        createdByFullName
        forkMode
        latestAttemptedReleaseVersion
        clonedReleaseVersion
        currentProjectStatus
        ${ProjectSqlContentCountFields}
      }
    }
  `);
export const ProjectAboutQuery = graphql(`
    query ProjectAboutQuery($projectId: String!) {
      Project(uid: $projectId) {
        _id
        description
        readme
        team {
          _id
          name
        }
        providerType
        created
        createdByFullName
        forkMode
        latestAttemptedReleaseVersion
        clonedReleaseVersion
        ${ProjectContentCountFields}
      }
    }
  `);
export const PackageLatestReleaseQuery = graphql(`
  query PackageAboutQuery($projectId: String!) {
    ProjectReleaseSnapshot(uid: $projectId) {
      _id
      latestAttemptedReleaseVersion
    }
  }
`);
export const projectTemplatesQuery = graphql(`
  query projectTemplatesQuery($projectId: String!, $branch: String) {
    Project(uid: $projectId) {
      defaultTemplate
      templates {
        _id
        versionedAspects(branch: $branch, aspectVers: [{ aspect: Configuration }]) {
          VersionedAspectName
          VersionedAspectValue
        }
      }
    }
  }
`);
export const ProjectGitStatusQuery = graphql(`
  query ProjectGitStatusQuery($projectId: String!) {
    Project(uid: $projectId) {
      forkMode
      syncMode
      versionControlMode
      currentProjectStatus
      externalOriginUri
      externalSyncStatus {
        url
        state
        displayState
        displayMessage
      }
      savedGitCredsStatus {
        ${userGitCredsQuery}
      }
      
    }
  }
`);
export const gitCodeQuery = graphql(`
  query gitCodeQuery($projectId: String!) {
    Project(uid: $projectId) {
      syncMode
      workingGitContext {
        currentUrl
      }
    }
  }
`);
export const subscriberTeamsQuery = graphql(`
  query subscriberTeamsQuery($projectId: String!) {
    Project(uid: $projectId) {
      name
      subscriberTeams {
        name
        subscribedProjectID
        isAuthor
        _id
      }
    }
  }
`);
export const packageSubscriberTeamsQuery = graphql(`
  query packageSubscriberTeamsQuery($projectId: String!) {
    ProjectReleaseSnapshot(uid: $projectId) {
      subscriberTeamsValidForUser {
        _id
      }
    }
  }
`);
export const subscribedDatasetsQuery = graphql(`
  query subscribedDatasetsQuery($projectId: String!) {
    Project(uid: $projectId) {
      subscribedDatasets {
        _id
        name
        project {
          _id
          name
        }
      }
    }
  }
`);
export const createProjectWithExternalGitEntityMutationQuery = graphql(`
  mutation createProjectEntity(
    $name: String!
    $ownerUID: String!
    $mainBranch: String!
    $language: BackEndCodeLanguage
    $backendLanguage: BackEndCodeLanguage
    $forkMode: ForkMode!
    $dependencyProjectUIDs: [String!]
    $externalUriArg: String
    $externalSubPath: String
    $externalRepoEmail: String
    $externalRepoUsername: String
    $externalRepoAccessToken: String
    $externalGitProvider: ExternalGitProviderType
    $userGitCredsUID: Long
    $description: String
    $providerType: String
    $versionControlMode: VersionControlMode!
    $isImport: Boolean
    $defaultDevelopmentBranch: String
    $defaultTransformationEntity: DefaultTransformationEntity
  ) {
    addProject(
      name: $name
      ownerUID: $ownerUID
      mainBranch: $mainBranch
      language: $language
      backendLanguage: $backendLanguage
      forkMode: $forkMode
      dependencyProjectUIDs: $dependencyProjectUIDs
      externalUriArg: $externalUriArg
      externalSubPath: $externalSubPath
      externalRepoEmail: $externalRepoEmail
      externalRepoUsername: $externalRepoUsername
      externalRepoAccessToken: $externalRepoAccessToken
      userGitCredsUID: $userGitCredsUID
      externalGitProvider: $externalGitProvider
      description: $description
      providerType: $providerType
      versionControlMode: $versionControlMode
      isImport: $isImport
      defaultDevelopmentBranch: $defaultDevelopmentBranch
      defaultTransformationEntity: $defaultTransformationEntity
    ) {
      _id
      name
    }
  }
`);
export const createProjectWithoutExternalGitEntityMutationQuery = graphql(`
  mutation createProjectEntity(
    $name: String!
    $ownerUID: String!
    $mainBranch: String!
    $language: BackEndCodeLanguage
    $backendLanguage: BackEndCodeLanguage
    $forkMode: ForkMode!
    $dependencyProjectUIDs: [String!]
    $userGitCredsUID: Long
    $description: String
    $providerType: String
    $versionControlMode: VersionControlMode!
    $isImport: Boolean
    $defaultTransformationEntity: DefaultTransformationEntity
  ) {
    addProject(
      name: $name
      ownerUID: $ownerUID
      mainBranch: $mainBranch
      language: $language
      backendLanguage: $backendLanguage
      forkMode: $forkMode
      dependencyProjectUIDs: $dependencyProjectUIDs
      userGitCredsUID: $userGitCredsUID
      description: $description
      providerType: $providerType
      versionControlMode: $versionControlMode
      isImport: $isImport
      defaultTransformationEntity: $defaultTransformationEntity
    ) {
      _id
      name
    }
  }
`);
export const unlinkExternalGitMutation = graphql(`
  mutation unlinkExternalGit($projectUID: String!) {
    unlinkExternalGit(projectUID: $projectUID)
  }
`);
export const linkInternalGitMutation = graphql(`
  mutation linkInternalGit($projectUID: String!) {
    linkInternalGit(projectUID: $projectUID)
  }
`);
export const linkExternalGitMutation = graphql(`
  mutation linkExternalGit(
    $projectUID: String!
    $externalRepoUri: String
    $externalRepoEmail: String
    $externalRepoUsername: String
    $externalRepoAccessToken: String
    $userGitCredsUID: Long
    $externalGitProvider: ExternalGitProviderType
  ) {
    linkExternalGit(
      projectUID: $projectUID
      externalRepoUri: $externalRepoUri
      externalRepoEmail: $externalRepoEmail
      externalRepoUsername: $externalRepoUsername
      externalRepoAccessToken: $externalRepoAccessToken
      userGitCredsUID: $userGitCredsUID
      externalGitProvider: $externalGitProvider
    )
  }
`);
export const linkSavedCredsToExternalGitMutation = graphql(`
  mutation linkSavedCredsToExternalGit(
    $projectUID: String!
    $externalRepoEmail: String
    $externalRepoUsername: String
    $externalRepoAccessToken: String
    $userGitCredsUID: Long
    $externalGitProvider: ExternalGitProviderType
  ) {
    linkSavedCredsToExternalGit(
      projectUID: $projectUID
      externalRepoEmail: $externalRepoEmail
      externalRepoUsername: $externalRepoUsername
      externalRepoAccessToken: $externalRepoAccessToken
      userGitCredsUID: $userGitCredsUID
      externalGitProvider: $externalGitProvider
    )
  }
`);
export const updateProject = graphql(`
  mutation UpdateProject(
    $uid: String!
    $projectDependency: String
    $buildSystemTemplatesEnabled: Boolean
    $changelogFile: String
    $projectDeploymentSettings: String
    $publishedProphecyPackage: Boolean
  ) {
    updateProject(
      uid: $uid
      projectDependency: $projectDependency
      buildSystemTemplatesEnabled: $buildSystemTemplatesEnabled
      changelogFile: $changelogFile
      projectDeploymentSettings: $projectDeploymentSettings
      publishedProphecyPackage: $publishedProphecyPackage
    ) {
      _id
    }
  }
`);
export const addTemplateQuery = graphql(`
  mutation AddTemplate($uid: String!, $name: String!) {
    addTemplate(ownerUID: $uid, name: $name) {
      _id
    }
  }
`);
export const UpdateGitTokenMutation = graphql(`
  mutation UpdateGitToken($uid: String!, $externalRepoAccessToken: String!) {
    updateGitToken(uid: $uid, externalRepoAccessToken: $externalRepoAccessToken)
  }
`);
export const cloneProjectMutation = graphql(`
  mutation cloneProject(
    $uid: String!
    $name: String!
    $teamUID: String!
    $externalSubPath: String
    $externalUriArg: String
    $externalRepoUsername: String
    $externalRepoEmail: String
    $externalRepoAccessToken: String
    $copyMainBranchReleaseTags: Boolean
    $userGitCredsUID: Long
    $externalGitProvider: ExternalGitProviderType
    $versionControlMode: VersionControlMode
    $defaultDevelopmentBranch: String
    $commitTemplate: String
  ) {
    cloneProject(
      uid: $uid
      name: $name
      teamUID: $teamUID
      externalSubPath: $externalSubPath
      externalUriArg: $externalUriArg
      externalRepoUsername: $externalRepoUsername
      externalRepoEmail: $externalRepoEmail
      externalRepoAccessToken: $externalRepoAccessToken
      copyMainBranchReleaseTags: $copyMainBranchReleaseTags
      userGitCredsUID: $userGitCredsUID
      externalGitProvider: $externalGitProvider
      versionControlMode: $versionControlMode
      defaultDevelopmentBranch: $defaultDevelopmentBranch
      commitTemplate: $commitTemplate
    ) {
      _id
      name
    }
  }
`);
export const migrateToExternalGitMutation = graphql(`
  mutation migrateToExternalGit(
    $uid: String!
    $externalSubPath: String
    $externalUriArg: String
    $externalRepoUsername: String
    $externalRepoEmail: String
    $externalRepoAccessToken: String
    $copyMainBranchReleaseTags: Boolean
    $userGitCredsUID: Long
    $externalGitProvider: ExternalGitProviderType
    $defaultMainBranch: String!
    $defaultDevelopmentBranch: String!
  ) {
    migrateToExternalGit(
      uid: $uid
      externalSubPath: $externalSubPath
      externalUriArg: $externalUriArg
      externalRepoEmail: $externalRepoEmail
      externalRepoUsername: $externalRepoUsername
      externalRepoAccessToken: $externalRepoAccessToken
      copyMainBranchReleaseTags: $copyMainBranchReleaseTags
      userGitCredsUID: $userGitCredsUID
      externalGitProvider: $externalGitProvider
      defaultMainBranch: $defaultMainBranch
      defaultDevelopmentBranch: $defaultDevelopmentBranch
    ) {
      _id
      name
    }
  }
`);
export const ClusterProjectCreationDefaultsQuery = graphql(`
  query ClusterProjectCreationDefaultsQuery {
    ClusterProjectCreationDefaults {
      language
      gitProviderType
      sqlProviderType
      versionControlType
      gitStorageModel
      defaultMainBranch
      defaultDevelopmentBranch
      gitStorageModel
    }
  }
`);
export const UpdateClusterProjectCreationDefaultsMutation = graphql(`
  mutation UpdateClusterProjectCreationDefaults(
    $language: BackEndCodeLanguage!
    $gitProviderType: GitProviderType!
    $versionControlMode: VersionControlMode
    $forkMode: ForkMode
    $defaultMainBranch: String
    $defaultDevelopmentBranch: String
    $sqlProviderType: String
  ) {
    updateClusterProjectCreationDefaults(
      language: $language
      gitProviderType: $gitProviderType
      versionControlMode: $versionControlMode
      forkMode: $forkMode
      defaultMainBranch: $defaultMainBranch
      defaultDevelopmentBranch: $defaultDevelopmentBranch
      sqlProviderType: $sqlProviderType
    )
  }
`);
export const ProjectDependenciesQuery = graphql(`
  query ProjectDependenciesQuery($projectId: String!) {
    Project(uid: $projectId) {
      latestReleaseVersion
      team {
        _id
      }
      language
      dependencies
      projectDependencyInfo {
        dependencies {
          version
          directDependency
          project {
            _id
            name
            description
            created
            latestReleaseVersion
            team {
              name
            }
          }
        }
        dependencyConflicts {
          project {
            name
          }
          conflictingReleaseVersionsSummary
        }
      }
    }
  }
`);
export const TeamProjectCreationDefaultsQuery = graphql(`
  query TeamProjectCreationDefaultsQuery($teamUID: String!) {
    TeamProjectCreationDefaults(teamUID: $teamUID) {
      language
      gitProviderType
      sqlProviderType
      versionControlType
      gitStorageModel
      defaultMainBranch
      defaultDevelopmentBranch
    }
  }
`);
export const UpdateTeamProjectCreationDefaultsMutation = graphql(`
  mutation UpdateTeamProjectCreationDefaults(
    $language: BackEndCodeLanguage!
    $gitProviderType: GitProviderType!
    $versionControlMode: VersionControlMode
    $forkMode: ForkMode
    $defaultMainBranch: String
    $defaultDevelopmentBranch: String
    $sqlProviderType: String
    $teamUID: String!
  ) {
    updateTeamProjectCreationDefaults(
      language: $language
      gitProviderType: $gitProviderType
      versionControlMode: $versionControlMode
      forkMode: $forkMode
      defaultMainBranch: $defaultMainBranch
      defaultDevelopmentBranch: $defaultDevelopmentBranch
      sqlProviderType: $sqlProviderType
      teamUID: $teamUID
    )
  }
`);
export const addOrUpdateCopilotLLMConfigMutation = graphql(`
  mutation addOrUpdateCopilotLLMConfig(
    $AIModelProvidersCreds: String!
    $availableAIModels: String!
    $availableAISpeechModels: String!
  ) {
    addOrUpdateCopilotLLMConfig(
      AIModelProvidersCreds: $AIModelProvidersCreds
      availableAIModels: $availableAIModels
      availableAISpeechModels: $availableAISpeechModels
    )
  }
`);
export const getCopilotLLMConfigQuery = graphql(`
  query getCopilotLLMConfig {
    getCopilotLLMConfig {
      AIModelProvidersCreds
      availableAIModels
      availableAISpeechModels
    }
  }
`);
export const setNetworkProxyConfigMutation = graphql(`
  mutation setNetworkProxyConfig($httpProxy: String, $httpsProxy: String) {
    setNetworkProxyConfig(httpProxy: $httpProxy, httpsProxy: $httpsProxy)
  }
`);
export const getOrchestrationSettingsQuery = graphql(`
  query getOrchestrationSettings {
    OrchestrationEndpoints {
      uid
      endpoint
      default
      masterKey {
        keyType
        keyValue
      }
    }
  }
`);
export const addOrchestrationEndpointMutation = graphql(`
  mutation addOrchestrationEndpoint(
    $endpointUrl: String!
    $default: Boolean!
    $masterKeyType: String!
    $masterKeyValue: String!
  ) {
    addOrchestrationEndpoint(
      endpointUrl: $endpointUrl
      default: $default
      masterKeyType: $masterKeyType
      masterKeyValue: $masterKeyValue
    )
  }
`);
export const updateOrchestrationEndpointMutation = graphql(`
  mutation updateOrchestrationEndpoint(
    $uid: String!
    $endpointUrl: String!
    $default: Boolean!
    $masterKeyType: String!
    $masterKeyValue: String!
  ) {
    updateOrchestrationEndpoint(
      uid: $uid
      endpointUrl: $endpointUrl
      default: $default
      masterKeyType: $masterKeyType
      masterKeyValue: $masterKeyValue
    )
  }
`);
export const removeOrchestrationEndpointMutation = graphql(`
  mutation removeOrchestrationEndpoint($uid: String!) {
    deleteOrchestrationEndpoint(uid: $uid)
  }
`);
export const removeProjectDependencyMutation = graphql(`
  mutation removeProjectDependencyMutation($projectId: String!, $dependencyProjectUID: String!) {
    removeProjectDependency(uid: $projectId, dependencyProjectUID: $dependencyProjectUID) {
      _id
      name
    }
  }
`);
export const addDefaultDependenciesMutation = graphql(`
  mutation addDefaultDependenciesMutation($teamUID: String!, $projectUIDs: [Long!]!) {
    addDefaultDependencies(teamUID: $teamUID, ProjectUIDs: $projectUIDs)
  }
`);
export const setAnalysisEnabledMutation = graphql(`
  mutation setAnalysisEnabled($projectUID: String!, $hasAnalysis: Boolean!) {
    setAnalysisEnabled(projectUID: $projectUID, hasAnalysis: $hasAnalysis)
  }
`);
export const removeDefaultDependenciesMutation = graphql(`
  mutation removeDefaultDependenciesMutation($teamUID: String!, $projectUIDs: [Long!]!) {
    removeDefaultDependencies(teamUID: $teamUID, ProjectUIDs: $projectUIDs)
  }
`);
export const addProjectDependencyMutation = graphql(`
  mutation addProjectDependencyMutation($projectId: String!, $dependencyProjectUID: String!, $releaseTag: String) {
    addProjectDependency(uid: $projectId, dependencyProjectUID: $dependencyProjectUID, releaseTag: $releaseTag) {
      _id
      name
    }
  }
`);
export const updateProjectDependencyMutation = graphql(`
  mutation updateProjectDependency($projectId: String!, $dependencyProjectUID: String!, $releaseTag: String!) {
    updateProjectDependency(uid: $projectId, dependencyProjectUID: $dependencyProjectUID, releaseTag: $releaseTag) {
      _id
      name
    }
  }
`);
export const updateProjectDependenciesMutation = graphql(`
  mutation updateProjectAllDependencies($projectId: String!) {
    updateProjectAllDependencies(uid: $projectId) {
      _id
      message
    }
  }
`);
export const prCreationTemplateQuery = graphql(`
  query getPrCreationTemplate($projectId: String!) {
    getPrCreationTemplate(projectUID: $projectId) {
      isPrCreationEnabled
      prTemplate
    }
  }
`);
export const prCreationTemplateMutation = graphql(`
  mutation setPrCreationTemplate($projectId: String!, $prCreationEnabled: Boolean!, $customPrTemplate: String) {
    setPrCreationTemplate(
      projectUID: $projectId
      prCreationEnabled: $prCreationEnabled
      customPrTemplate: $customPrTemplate
    )
  }
`);
export const prCreationURLQuery = graphql(`
  query prCreationRedirectUrl($projectId: String!, $from: String!, $to: String!) {
    prCreationRedirectUrl(projectUID: $projectId, from: $from, to: $to) {
      isPrCreationEnabled
      externalPrUrlRedirect
    }
  }
`);
export const updateTemplateMutation = graphql(`
  mutation updateTemplateVersionMutation($uid: String!) {
    updateTemplateVersion(uid: $uid) {
      name
    }
  }
`);
export const updateArtefactIDMutation = graphql(`
  mutation updateArtefactIDMutation($uid: String!, $entity: EntityKind!, $artefactID: String!) {
    updateArtefactID(uid: $uid, entityKind: $entity, artefactID: $artefactID)
  }
`);
export const updateParentArtefactIDForProjectMutation = graphql(`
  mutation updateParentArtefactIDForProjectMutation($uid: String!, $artefactID: String!) {
    updateParentArtefactIDForProject(uid: $uid, artefactID: $artefactID)
  }
`);
export const mergedExternallyMutation = graphql(`
  mutation mergedExternally($projectUID: String!, $from: String!, $to: String!) {
    mergedExternally(projectUID: $projectUID, from: $from, to: $to) {
      forkMode
    }
  }
`);
export const externalProjectDetailsQuery = graphql(`
  query externalProjectDetails(
    $externalUriArg: String!
    $branch: String!
    $externalSubPath: String!
    $externalRepoEmail: String
    $externalRepoUsername: String
    $externalRepoAccessToken: String
    $userGitCredsUID: Long
  ) {
    externalProjectDetails(
      externalUriArg: $externalUriArg
      externalRepoEmail: $externalRepoEmail
      branch: $branch
      externalRepoUsername: $externalRepoUsername
      externalRepoAccessToken: $externalRepoAccessToken
      externalSubPath: $externalSubPath
      userGitCredsUID: $userGitCredsUID
    ) {
      isValidProphecyProject
      isValidDbtProject
      name
      description
      language
      buildSystem
      existingProjectsMessage
      isSubpathCreationAllowedSimple
      backendLanguage
    }
  }
`);
export const UpdateProjectReadmeMutation = graphql(`
  mutation UpdateProjectReadmeMutation($projectUID: String!, $content: String!) {
    updateReadme(projectUID: $projectUID, content: $content)
  }
`);
export const ReleaseFromAnExistingTagMutation = graphql(`
  mutation ReleaseFromAnExistingTag($projectUID: String!, $fromReleaseTag: String!) {
    releaseFromAnExistingTag(projectUID: $projectUID, fromReleaseTag: $fromReleaseTag)
  }
`);
export const addOrUpdateTeamProjectCreationTemplateMutation = graphql(`
  mutation addOrUpdateTeamProjectCreationTemplate(
    $uid: String
    $teamUID: String!
    $name: String!
    $isDefault: Boolean!
    $allowToCustomize: Boolean!
    $language: BackEndCodeLanguage!
    $gitProviderType: GitProviderType!
    $gitCombinedStorageModel: GitCombinedStorageModel!
    $sqlProviderType: String
    $defaultMainBranch: String
    $defaultDevelopmentBranch: String
    $defaultTransformationEntity: DefaultTransformationEntity
  ) {
    addOrUpdateTeamProjectCreationTemplate(
      uid: $uid
      teamUID: $teamUID
      name: $name
      isDefault: $isDefault
      allowToCustomize: $allowToCustomize
      language: $language
      gitProviderType: $gitProviderType
      gitCombinedStorageModel: $gitCombinedStorageModel
      sqlProviderType: $sqlProviderType
      defaultMainBranch: $defaultMainBranch
      defaultDevelopmentBranch: $defaultDevelopmentBranch
      defaultTransformationEntity: $defaultTransformationEntity
    )
  }
`);
export const teamProjectCreationTemplatesQuery = graphql(`
  query teamProjectCreationTemplates($teamUID: String!) {
    TeamProjectCreationTemplates(teamUID: $teamUID) {
      uid
      teamUID
      name
      isDefault
      allowToCustomize
      language
      gitProviderType
      gitCombinedStorageModel
      sqlProviderType
      defaultMainBranch
      defaultDevelopmentBranch
      defaultTransformationEntity
    }
  }
`);
export const getProjectStatusConfigQuery = graphql(`
  query getProjectStatusConfig {
    getProjectStatusConfig {
      entryName
      colour
      isAdminEntry
      emailEnabled
    }
  }
`);
export const setProjectStatusConfigMutation = graphql(`
  mutation setProjectStatusConfig($projectStatusConfig: [ProjectStatusEntry!]!) {
    setProjectStatusConfig(projectStatusConfig: $projectStatusConfig)
  }
`);
export const ListProjectFilesQuery = graphql(`
  query ListProjectFiles(
    $uid: String!
    $subPath: String
    $fromRepositoryRoot: Boolean
    $typeFilters: [FileEntryType!]
  ) {
    ListProjectFiles(uid: $uid, subPath: $subPath, fromRepositoryRoot: $fromRepositoryRoot, typeFilters: $typeFilters) {
      rootPath
      totalFiles
      files {
        path
        entryType
      }
    }
  }
`);
